import {
  TransactionItemDrawerMode,
  TransactionItemDrawerModeEnum,
} from '@/features/transaction_items/List/type';
import { UnsupportedPlanWarning } from '@/features/transaction_items/components/UnsupportedPlanWarning/UnsupportedPlanWarning';
import { useTranslation } from '@/i18n';
import { useGlobalContainerRef } from '@/wc/helper/ref';
import {
  ButtonGroup,
  ButtonV2,
  Tooltip,
} from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo } from 'react';
import styles from './Header.module.scss';

export type Props = {
  mode: TransactionItemDrawerMode;
  onSetMode: (mode: TransactionItemDrawerMode) => void;
  isLoading: boolean;
  onDeleteClick: () => void;
  canDelete?: boolean;
  deleteTooltip?: string;
  isSupportedOffice?: boolean;
};

const cx = classNames.bind(styles);

export const TransactionItemHeader: FC<Props> = memo(
  ({
    mode,
    onSetMode,
    isLoading,
    onDeleteClick,
    canDelete,
    deleteTooltip,
    isSupportedOffice,
  }) => {
    const { t } = useTranslation();
    const globalContainer = useGlobalContainerRef();
    const isDeleteDisabled = canDelete === false || isLoading;

    const deleteButton = (
      <ButtonV2
        isSecondary
        color='danger'
        isDisabled={isDeleteDisabled}
        onClick={onDeleteClick}
      >
        {t('delete')}
      </ButtonV2>
    );

    return (
      <div className={cx(styles['title'])}>
        {t(`transaction_items.drawer.${mode}.title`)}
        {!isSupportedOffice && <UnsupportedPlanWarning />}
        {mode === TransactionItemDrawerModeEnum.DETAIL && (
          <ButtonGroup direction='horizontal'>
            <Tooltip
              title={
                canDelete === false && deleteTooltip ? deleteTooltip : undefined
              }
              placement='bottom'
              getPopupContainer={globalContainer}
            >
              <span>{deleteButton}</span>
            </Tooltip>
            {isSupportedOffice && (
              <ButtonV2
                onClick={() => onSetMode(TransactionItemDrawerModeEnum.EDIT)}
                isSecondary
                isDisabled={isLoading}
              >
                {t('edit')}
              </ButtonV2>
            )}
          </ButtonGroup>
        )}
      </div>
    );
  }
);
TransactionItemHeader.displayName = 'TransactionItemHeader';
